/**
 * The benchmark is this factor times the (highest) service reclaim percentage for the pro.
 */
export const RECLAIM_PERCENTAGE_BENCHMARK_FACTOR = 2 / 3
